import { render, staticRenderFns } from "./luckyNangkwak.vue?vue&type=template&id=dd752d48"
import script from "./luckyNangkwak.vue?vue&type=script&lang=js"
export * from "./luckyNangkwak.vue?vue&type=script&lang=js"
import style0 from "./luckyNangkwak.vue?vue&type=style&index=0&id=dd752d48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports